import {Component, computed, input} from '@angular/core';
import {NgIf} from '@angular/common';
import {TranslocoDirective} from '@jsverse/transloco';
import {AbstractControl} from '@angular/forms';
import {AbstractFieldComponent, ValidationError} from '@shared/field/abstract-field.component';

@Component({
  selector: 'app-field-wrapper',
  imports: [
    NgIf,
    TranslocoDirective
  ],
  templateUrl: './field-wrapper.component.html',
  styleUrl: './field-wrapper.component.scss'
})
export class FieldWrapperComponent {
  public readonly field = input.required<AbstractFieldComponent<AbstractControl>>();
  public readonly showLabel = input<boolean>(true);
  public readonly showErrors = input<boolean>(true);
  public readonly showRequired = input<boolean>(true);

  // TODO: regroup all translation keys consts
  private static readonly KEY_REQUIRED = 'required';

  public readonly errors = computed(() => {
    const field = this.field();
    if (!(this.showErrors() && field?.typedControl()?.invalid)) {
      return [] as ValidationError[];
    }
    const errors = (field?.errors() ?? []);
    return this.showRequired()
      ? errors
      : errors.filter(error => error.key !== FieldWrapperComponent.KEY_REQUIRED);
  });
}
